import { put } from 'redux-saga/effects';
import { apiErrorAction } from '../actions/apiErrorActions';
import { resetApp } from 'containers/App/session/actions';


export function* withApiErrorHandling(generator) {
    try {
        yield* generator();
    } catch (e1) {
        if (e1.response && e1.response.status && e1.response.status === 403) {
            yield put(resetApp());
        }
        let { response } = e1;
        if (e1.response === undefined) {
            response = { status: 500 };
        }
        yield put(apiErrorAction(response));
    }
}
